import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
  urlMappingId: string;
};

export const UrlMappingEditPage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, siteSlug, urlMappingId }) => {
  const breadcrumbs = useMemo(
    () => [
      {
        label: "URLマッピング",
        path: `/sites/${siteSlug}/settings?tab=url_mappings`,
      },
      {
        label: "URLマッピング編集",
        path: `/sites/${siteSlug}/url_mappings/${encodeURIComponent(
          urlMappingId
        )}/edit`,
      },
    ],
    [siteSlug, urlMappingId]
  );

  return (
    <PageLayout title="URLマッピング編集" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
